import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FundingModel } from '@bp-core/src/lib/proto/common-message.pb';
import { SummaryFunding } from '@bp-core/src/lib/proto/funding.pb';
import { defaultIconClass } from './constants';

@Component({
  selector: 'app-discover-fund-avatar',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './discover-fund-avatar.component.html',
  styleUrls: ['./discover-fund-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoverFundAvatarComponent {
  @Input() fund: SummaryFunding | FundingModel;
  @Input() index?: number;
  @Input() size = '32px';
  @Input() showDefaultIcon = true;
  getRandomIconName(index?: number) {
    if (!index) {
      return defaultIconClass[0];
    }
    // si indice es menor que 5 retorna defaultIconClass el indice, no puede pasar de 5, es decir se debe repetir el array
    return defaultIconClass[index % 5];
  }
}
